import { render, staticRenderFns } from "./SurveyElement.vue?vue&type=template&id=005b99b5&"
import script from "./SurveyElement.vue?vue&type=script&lang=ts&"
export * from "./SurveyElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports